<template>
  <section class="profileColumn" :style="cssProps" :class="{
    profileColumnExpanded: $store.state.display.leftColumn.starredMessage.isExpanded,
    profileColumnCollapsed: !$store.state.display.leftColumn.starredMessage
      .isExpanded
  }"
  >
    <div class="topBar">
      <a class="closeColumnBtn" @click="closeProfileColumn()">
        <img src="@/assets/images/left-arrow.png">
      </a>
      <div class="topBarTitle">
        Yıldızlı Mesajlar
      </div>
    </div>

    <div class="transitionContainer">
      <StarredMessages />
    </div>
  </section>
</template>

<script>
import EventBus from '@/eventbus.js'
import StarredMessages from './StarredMessages.vue'
import {
  socketOutputMixin
} from '@/mixins/socketOutputMixin.js'
export default {
  components: {
    StarredMessages
  },
  mixins: [socketOutputMixin],
  data () {
    return {
      uploadFileObj: {},
      isVisibleNameInEditMode: false,
      isVisibleNameError: false,
      isStatusTextInEditMode: false,
      isTitleInEditMode: false,
      isDepartmentInEditMode: false,
      isEmailInEditMode: false,
      isMobileInEditMode: false,
      isInternalInEditMode: false
    }
  },
  computed: {
    cssProps () {
      return {
        '--topBarColor': this.$config.theme.default.sideMenu.topBarColor,
        '--fontColor': this.$config.theme.default.sideMenu.fontColor,
        '--buttonColor': this.$config.theme.default.sideMenu.buttonColor
      }
    }
  },
  methods: {
    closeProfileColumn () {
      this.$store.state.display.leftColumn.starredMessage.isExpanded = false
    }
  },
  created () {
    this.get_stars()
  }
}

</script>

<style scoped>
  @error-border-color: rgb(223, 100, 100);
  @border-color: rgb(223, 223, 223);
  .transitionContainer {
    overflow-y: scroll;
    overflow-x: hidden;
    height: calc(100% - 118px);
  }
    .transitionContainer::-webkit-scrollbar {
    width: 2px;
  }

  .transitionContainer::-webkit-scrollbar-thumb {
    background-color: rgb(155, 155, 155);
  }
  .topBar {
    background-color: var(--topBarColor);
    height: 80px;
    display: flex;
    align-items: flex-end;
  }

  .topBarTitle {
    color: white;
    font-size: 16px;
    font-weight: 700;
    margin: 10px;
    line-height: 40px;
  }

  .profileColumn {
    height: 100%;
    background-color: white;
    position: absolute;
    top: 0px;
    width: 100%;
    left: -100%;
    z-index: 999;
    overflow: hidden;
  }

  .profileColumnExpanded {
    left: 0px;
    transition: left 0.3s;
  }

  .profileColumnCollapsed {
    left: -100%;
    width: 100%;
    transition: left 0.3s;
  }

  .closeColumnBtn {
    cursor: pointer;
  }

  .closeColumnBtn>img {
    width: 30px;
    height: 30px;
    margin: 10px;
    margin-left: 20px;
  }

  .profileContainer {
    background-color: #eaeceb;
    width: 100%;
    height: calc(100% - 80px);
    overflow-y: scroll;
  }

  .profilePhotoDiv {
    text-align: center;
    padding-top: 50px;
    position: relative;
  }

  .avatarImg {
    margin: auto;
    width: 220px;
    height: 220px;
    border-radius: 50%;
    background-color: #fff;
    object-fit: cover;
  }

  .textRow {
    margin-top: 0px;
    background-color: white;
    padding: 20px;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .nameTitle {
    font-size: 10px;
    font-weight: 700;
    color: var(--fontColor);
    padding-bottom: 10px;
  }

  .photoHover {
    display: block;
    opacity: 0;
    width: 220px;
    height: 220px;
    border-radius: 50%;
    top: calc(50% - 97px);
    left: calc(50% - 110px);
    background-color: RGBA(0, 0, 0, 0.8);
    position: absolute;
    cursor: pointer;
  }

  .photoHover:hover {
    display: block;
    opacity: 1;
  }

  .photoMenuItem {
    padding: 10px;
    font-size: 13px;
    font-weight: 400;
    margin-bottom: 1px;
    background-color: white;
    cursor: pointer;
  }

  .photoMenuItem:hover {
    background-color: #F0F0F0;
  }

  .editCont {
    display: flex;
    align-items: center;
    margin: 10px;
    margin-top: 0px;
    margin-bottom: 5px;
    text-align: left;
  }

  .editable {
    border-bottom: 1px solid rgb(223, 223, 223);
  }

  .error {
    border-bottom: 1px solid rgb(223, 100, 100);
  }

  .editInput {
    height: 25px;
    flex-grow: 1;
    flex-shrink: 0;
  }

  .imgEdit {
    width: 15px;
    height: 15px;
    flex-grow: 0;
    margin-right: 10px;
    cursor: pointer;
  }

  .editInput:focus {
    outline: none;
  }

</style>

<style>
  .bp-dropdown__body {
    background-color: #d8dcdb;
    padding: 1px;
    width: 170px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }

</style>
